<template>
  <v-layout column>
    <v-flex>
      <v-layout
        align-center
        px-3
        pt-3
      >
        <v-layout class="title">
          <pre>Звено </pre>
          <span class="font-weight-bold">Заезд</span>
          <v-spacer />
          <span class="font-weight-bold">{{ route ? route : "" }}</span>
          <v-spacer />
          <span class="font-weight-bold">{{ vehicle ? vehicle : "" }}</span>
        </v-layout>
        <v-spacer />
        <h2 class="subheading font-weight-bold">
          <span
            :class="{
              'orange--text': phasesState.id == phaseStates.AWAITING,
              'purple--text': phasesState.id == phaseStates.INROUTE,
              'primary--text': phasesState.id == phaseStates.INPROCESS,
              'green--text': phasesState.id == phaseStates.DONE
            }"
          >{{ phasesState.title }}</span>
        </h2>
        <v-btn
          v-if="isPhasesStateChange"
          :disabled="isNew || isChanged || disabled"
          color="primary ml-0 mr-3"
          small
          @click="phasesStateChanged"
        >
          {{
            phasesState.id == phaseStates.AWAITING
              ? "В маршруте"
              : phasesState.id == phaseStates.INROUTE
                ? "В процессе"
                : phasesState.id == phaseStates.INPROCESS
                  ? "Завершить"
                  : phasesState.id == phaseStates.DONE
                    ? "В процессе"
                    : ""
          }}
        </v-btn>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-form
        v-model="valid"
        class="pa-3"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            md2
            xs12
          >
            <EnumSelect
              v-model="transportType"
              class="ma-1"
              label="Тип транспорта*"
              resource="transport-types"
              disabled
              :without-selected="false"
              :outline="true"
              :height-field="44"
            />
          </v-flex>
          <v-flex
            md5
            xs12
          >
            <v-text-field
              v-model="sendingPoint"
              class="ma-1"
              label="Отправка"
              disabled
              hide-details
              outline
              height="44"
            />
          </v-flex>
          <v-flex
            md5
            xs12
          >
            <v-text-field
              v-model="sendingPointAddress"
              class="ma-1"
              label="Адрес погрузки*"
              disabled
              hide-details
              outline
              height="44"
            />
          </v-flex>
        </v-layout>
        <v-flex v-if="counterparty">
          <v-text-field
            v-model="counterparty"
            class="ma-1"
            label="Контрагент"
            disabled
            hide-details
            outline
            height="44"
          />
        </v-flex>
        <v-flex>
          <v-radio-group
            v-model="arrivalType"
            hide-details
            row
            class="mt-2"
          >
            <h2
              :class="[
                { 'grey--text': phasesState.id == phaseStates.DONE },
                'subheading',
                'mx-2'
              ]"
            >
              Место прибытия:
            </h2>
            <v-radio
              v-for="(item, value) in arrivalTypes"
              :key="value"
              :label="item.text"
              :value="item"
              :disabled="isDisabledPhase"
              class="mb-1"
              @change="arrivalTypeChanged"
            />
          </v-radio-group>
        </v-flex>
        <v-layout
          row
          wrap
        >
          <v-flex
            md6
            xs12
          >
            <app-reference
              v-if="arrivalType.value !== unloadingPlaceTypes.ADDRESS"
              v-model="arrivalPoint"
              class="ma-1"
              label="Прибытие*"
              :disabled="isDisabledPhase"
              :resource="arrivalType.resource"
              :component-name="arrivalType.component"
              :filter-name="
                arrivalType.value === unloadingPlaceTypes.GROUPEDWAREHOUSE ||
                  arrivalType.value === unloadingPlaceTypes.OTHERWAREHOUSE
                  ? 'groupedWarehouse'
                  : ''
              "
              :filter-value="
                arrivalType.value === unloadingPlaceTypes.GROUPEDWAREHOUSE
                  ? true
                  : arrivalType.value === unloadingPlaceTypes.OTHERWAREHOUSE
                    ? false
                    : null
              "
              :outline="true"
              :height-field="44"
              :rules="[v => !!v || '']"
              required
              @input="arrivalPointChanged"
            />
          </v-flex>
          <v-flex
            md6
            xs12
          >
            <ArrivalPlaceReference
              v-if="arrivalType.value == unloadingPlaceTypes.FACTORY"
              v-model="arrivalPointAddress"
              class="ma-1"
              label="Адрес прибытия*"
              :factory-id="arrivalPoint ? arrivalPoint.id : 0"
              :disabled="isDisabledPhase"
              @input="phaseChanged"
            />

            <v-text-field
              v-if="
                arrivalType.value == unloadingPlaceTypes.GROUPEDWAREHOUSE ||
                  arrivalType.value == unloadingPlaceTypes.OTHERWAREHOUSE
              "
              v-model="arrivalPointWarehouseAddress"
              class="ma-1"
              label="Адрес прибытия*"
              :rules="[v => !!v || '']"
              hide-details
              outline
              height="44"
              :disabled="isDisabledPhase"
              @change="phaseChanged"
            />
          </v-flex>
          <v-flex
            v-if="arrivalType.value == unloadingPlaceTypes.ADDRESS"
            md12
            xs12
          >
            <app-reference
              v-model="arrivalPointAddress"
              class="ma-1"
              label="Адрес прибытия*"
              :resource="arrivalType.resource"
              :component-name="arrivalType.component"
              :parent-id="arrivalPoint ? arrivalPoint.id : 0"
              :rules="[v => !!v || '']"
              :outline="true"
              :height-field="44"
              :disabled="isDisabledPhase"
              @input="phaseChanged"
            />
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex
            md6
            xs12
          >
            <app-date-picker
              v-model="loadingDate"
              class="ma-1"
              label="Дата погрузки"
              :outline="true"
              :height-field="44"
              :disabled="isDisabledPhase"
              :without-initial-data="true"
              :with-autocomplete="true"
              :clearable="true"
              @input="phaseChanged"
            />
          </v-flex>
          <v-flex
            md6
            xs12
          >
            <app-date-picker
              v-model="unloadingDate"
              class="ma-1"
              label="Дата прибытия"
              :min="loadingDate"
              :outline="true"
              :height-field="44"
              :disabled="isDisabledPhase"
              :without-initial-data="true"
              :with-autocomplete="true"
              :clearable="true"
              @input="phaseChanged"
            />
          </v-flex>
        </v-layout>
        <v-flex
          v-if="isNew"
          class="mb-3"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-textarea
                v-model="notes"
                class="ma-1"
                label="Комментарий"
                hide-details
                rows="1"
                auto-grow
                outline
                v-bind="attrs"
                @change="phaseChanged"
                v-on="on"
              />
            </template>
            <span>Страховка, тип загрузки, хрупкость, нюансы погрузки и
              другое</span>
          </v-tooltip>
        </v-flex>
        <HistoryComments
          v-else
          :comments="currentComments"
          :loading="phaseLoading"
          tooltip="Страховка, тип загрузки, хрупкость, нюансы погрузки и другое"
          :is-disabled-add="isDisabledAddComment"
          @add="addComment"
          @delete="deleteComment"
        />
        <v-layout
          align-center
          justify-end
          class="pt-3"
        >
          <v-flex>
            <v-btn
              small
              color="primary"
              :disabled="!valid || !isChanged"
              :loading="phaseLoading"
              @click="save"
            >
              Сохранить
            </v-btn>
            <v-btn
              small
              @click="$emit('cancel')"
            >
              Oтмена
            </v-btn>
          </v-flex>
          <v-spacer />
          <v-menu
            offset-y
            left
            top
          >
            <template v-slot:activator="{ on }">
              <DeletePhasesButton
                :is-in-route="isInRoute"
                :disabled="isDeletePhasesButtonDisabled"
                v-on="on"
              />
            </template>
            <v-card>
              <v-card-title>
                Вы действительно хотите удалить звено?
              </v-card-title>
              <v-card-actions>
                <v-layout
                  align-center
                  justify-end
                >
                  <v-btn
                    small
                    flat
                    color="primary"
                    @click="remove"
                  >
                    Ок
                  </v-btn>
                  <v-btn
                    small
                    flat
                    @click="$emit('cancel')"
                  >
                    Oтмена
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<script>
import ArrivalPlaceReference from "./ArrivalPlaceReference.vue";
import HistoryComments from "../../../../components/HistoryComments.vue";
import DeletePhasesButton from "./DeletePhasesButton.vue";
import { phaseStates } from "./shipping-phase-states.js";
import * as shippingsApi from "../../../../backend/shippingsApi.js";
import * as phasesApi from "../../../../backend/phasesApi.js";
import { unloadingPlaceTypes } from "../../../../enums/unloading-place-types.js";
import { userRoles } from "../../../../enums/user-roles.js";

export default {
  components: {
    ArrivalPlaceReference,
    HistoryComments,
    DeletePhasesButton,
  },
  props: [
    "value",
    "isLastPhase",
    "disabled",
    "user",
    "fromRoute",
    "isDisabledAddComment",
  ],
  data() {
    return {
      valid: true,
      arrivalType: null,
      isChanged: false,
      transportType: 2,
      counterparty: null,
      arrivalPoint: null,
      arrivalPointAddress: null,
      loadingDate: null,
      unloadingDate: null,
      senderFactory: null,
      senderWarehouse: null,
      senderAddress: null,
      notes: "",
      currentComments: [],
      phasesState: null,
      isNew: false,
      phaseLoading: false,
    };
  },
  computed: {
    phases() {
      return this.$store.getters["shipping/phases"];
    },
    isAdmin() {
      return !!this.user.roles.find(r => r.id === userRoles.Admin);
    },
    isLogist() {
      return !!this.user.roles.find(r => r.id === userRoles.Logist);
    },
    phaseStates() {
      return phaseStates;
    },
    arrivalTypes() {
      return [
        {
          value: this.unloadingPlaceTypes.FACTORY,
          text: "Склад продавца",
          resource: "factories",
          component: "Factory",
        },
        {
          value: this.unloadingPlaceTypes.GROUPEDWAREHOUSE,
          text: "Группажный склад",
          resource: "warehouses",
          component: "Warehouse",
        },
        {
          value: this.unloadingPlaceTypes.ADDRESS,
          text: "Другое",
          resource: "addresses",
          component: "Address",
        },
        {
          value: this.unloadingPlaceTypes.OTHERWAREHOUSE,
          text: "Другой склад",
          resource: "warehouses",
          component: "Warehouse",
        },
      ];
    },
    shippingSender() {
      return this.$store.getters["shipping/sender"];
    },
    shippingSenderAddress() {
      return this.$store.getters["shipping/senderAddress"];
    },
    shippingId() {
      return this.$store.getters["shipping/id"];
    },
    unloadingPlaceTypes() {
      return unloadingPlaceTypes;
    },
    sendingPoint() {
      return this.senderFactory?.title || this.senderWarehouse?.title || "";
    },
    sendingPointAddress() {
      return this.senderAddress?.title || "";
    },
    ourWarehouse() {
      return this.$store.getters["shipping/ourWarehouse"];
    },
    arrivalPointWarehouseAddress() {
      return this.arrivalPointAddress?.title || "";
    },
    route() {
      return this.value?.route?.title || "";
    },
    vehicle() {
      return this.value?.vehicle?.title || "";
    },
    isDisabledPhase() {
      if (
        !!this.user.roles.find(r => r.id === userRoles.ClientManager) &&
        this.value?.allowEditing
      ) {
        return false;
      }
      if (!this.isNew && this.isAdmin) {
        if (this.value.isLast && this.value.state.id === phaseStates.DONE) {
          return true;
        } else if (!this.value.isLast) {
          return false;
        }
      } else if (
        !this.isNew &&
        this.value.isLast &&
        this.phasesState.id == phaseStates.DONE
      ) {
        return true;
      }
      return this.phasesState.id == phaseStates.DONE || this.disabled;
    },
    phasesWithRerouting() {
      return this.$store.getters["shipping/phasesWithRerouting"];
    },
    isDeletePhasesButtonDisabled() {
      if (!this.isNew && this.isAdmin) {
        if (
          this.value?.isLastPhaseDone &&
          this.phasesState.id === this.phaseStates.DONE
        ) {
          return true;
        } else {
          return false;
        }
      } else if (
        this.isNew ||
        this.phasesState.id != this.phaseStates.AWAITING ||
        !this.isLastPhase ||
        this.disabled
      ) {
        return true;
      } else {
        return false;
      }
    },
    isInRoute() {
      return !!this.route;
    },
    isPhasesStateChange() {
      if (this.isLogist || this.isAdmin) {
        return this.value?.allowChangeState && this.value?.changeState;
      } else {
        return this.value?.changeState || true;
      }
    },
  },
  created() {
    this.initSenderPoint();
    if (this.value) {
      this.initPhase(this.value);
    } else {
      this.isNew = true;
      this.phasesState = this.getPhasesState(phaseStates.AWAITING);
      this.arrivalType = this.arrivalTypes[3];
      this.arrivalTypeChanged(this.arrivalTypes[3]);
    }
  },
  beforeDestroy() {
    if (!this.phasesWithRerouting.length) {
      return;
    }
    this.$store.dispatch("shipping/unmarkPhasesWithRerouting", {
      shippingId: this.shippingId,
      phaseId: this.value.id,
    });
  },
  methods: {
    initSenderPoint() {
      if (this.phases.length > 0 && !this.value) {
        this.senderFactory = this.phases[
          this.phases.length - 1
        ].arrivalPoint?.factory;
        this.senderWarehouse = this.phases[
          this.phases.length - 1
        ].arrivalPoint?.warehouse;
        this.senderAddress = this.phases[
          this.phases.length - 1
        ].arrivalPoint?.address;
      } else if (this.phases.length === 0 && !this.value) {
        this.senderFactory =
          this.shippingSender.type === 0 ? this.shippingSender : null;
        this.senderWarehouse =
          this.shippingSender.type === 1 ? this.shippingSender : null;
        this.senderAddress = this.shippingSenderAddress;
      }
    },
    initPhase(value) {
      this.counterparty = value.counterparty?.carrier?.title || "";
      this.arrivalType = value.arrivalPoint.factory
        ? this.arrivalTypes[0]
        : value.arrivalPoint.warehouse &&
          value.arrivalPoint.warehouse.groupedWarehouse
          ? this.arrivalTypes[1]
          : value.arrivalPoint.warehouse &&
          !value.arrivalPoint.warehouse.groupedWarehouse
            ? this.arrivalTypes[3]
            : this.arrivalTypes[2];
      this.arrivalPoint = value.arrivalPoint.factory
        ? value.arrivalPoint.factory
        : value.arrivalPoint.warehouse
          ? value.arrivalPoint.warehouse
          : null;
      this.arrivalPointAddress = value.arrivalPoint?.address;
      this.loadingDate = value.loadingDate;
      this.unloadingDate = value.unloadingDate;
      this.senderFactory = value.sendingPoint?.factory;
      this.senderWarehouse = value.sendingPoint?.warehouse;
      this.senderAddress = value.sendingPoint?.address;
      this.phasesState = this.getPhasesState(value.state.id);
      this.currentComments = value.comments;
      this.markAsReadComments();
    },
    async save() {
      this.phaseLoading = true;
      const phase = {
        transportType: this.transportType,
        arrivalPointWarehouseId:
          this.arrivalType.value ===
            this.unloadingPlaceTypes.GROUPEDWAREHOUSE ||
          this.arrivalType.value === this.unloadingPlaceTypes.OTHERWAREHOUSE
            ? this.arrivalPoint.id
            : null,
        arrivalPointFactoryId:
          this.arrivalType.value === this.unloadingPlaceTypes.FACTORY
            ? this.arrivalPoint.id
            : null,
        arrivalPointAddressId: this.arrivalPointAddress.id,
        sendingPointWarehouseId: this.senderWarehouse?.id,
        sendingPointFactoryId: this.senderFactory?.id,
        sendingPointAddressId: this.senderAddress.id,
        loadingDate: this.loadingDate,
        unloadingDate: this.unloadingDate,
      };

      let phaseId = 0;
      if (!this.value) {
        phaseId = await phasesApi.createPickupPhase(this.shippingId, phase);
      } else {
        await phasesApi.updatePickupPhase(
          this.shippingId,
          this.value.id,
          phase,
          this.fromRoute,
        );
      }
      if (this.notes) {
        await phasesApi.addComment(
          this.value?.id || phaseId,
          this.notes,
          this.fromRoute,
        );
      }
      this.showInfo(this.value ? "Изменения сохранены" : "Звено добавлено");
      if (this.fromRoute) {
        this.$emit("update");
      } else {
        await this.$store.dispatch("shipping/getPhases", this.shippingId);
      }
      this.$emit("cancel");
      this.phaseLoading = false;
    },
    arrivalTypeChanged(type) {
      this.arrivalPoint = null;
      this.arrivalPointAddress = null;
      if (type.value === this.unloadingPlaceTypes.OTHERWAREHOUSE) {
        this.arrivalPoint = this.ourWarehouse?.warehouse;
        this.arrivalPointAddress = this.ourWarehouse?.address;
      }
      this.phaseChanged();
    },
    async arrivalPointChanged() {
      if (!this.arrivalPoint) {
        this.arrivalPointAddress = null;
      }
      if (
        (this.arrivalType.value == this.unloadingPlaceTypes.GROUPEDWAREHOUSE &&
          this.arrivalPoint != null) ||
        (this.arrivalType.value == this.unloadingPlaceTypes.OTHERWAREHOUSE &&
          this.arrivalPoint != null)
      ) {
        const response = await shippingsApi.getWarehouse(this.arrivalPoint.id);
        this.arrivalPointAddress = {
          id: response.Address.Id,
          title: response.Address.Title,
        };
      }
      this.phaseChanged();
    },
    async remove() {
      this.phaseLoading = true;
      await phasesApi.deletePhase(this.shippingId, this.value.id);
      if (!this.fromRoute) {
        await this.$store.dispatch("shipping/getPhases", this.shippingId);
      }
      this.$emit("cancel");
      this.showInfo("Звено удалено");
      this.phaseLoading = false;
    },
    async phasesStateChanged() {
      const stateId =
        this.phasesState.id == phaseStates.AWAITING
          ? phaseStates.INPROCESS
          : this.phasesState.id == phaseStates.INPROCESS
            ? phaseStates.DONE
            : phaseStates.INPROCESS;

      this.phaseloading = true;
      await phasesApi.updatePhasesState(
        this.shippingId,
        this.value.id,
        stateId,
      );
      this.showInfo("Статус изменен");
      if (this.fromRoute) {
        this.$emit("update");
      } else {
        await this.$store.dispatch("shipping/getPhases", this.shippingId);
      }
      if (stateId === phaseStates.DONE) {
        this.$store.dispatch("shipping/updateDates", this.shippingId);
      }
      this.$emit("cancel");
      this.phaseloading = false;
    },
    phaseChanged() {
      this.isChanged = true;
    },
    getPhasesState(state) {
      switch (state) {
        case 1:
          return {
            id: phaseStates.AWAITING,
            value: "Awaiting",
            title: "В ожидании",
          };
        case 2:
          return {
            id: phaseStates.INROUTE,
            value: "InRoute",
            title: "В маршруте",
          };
        case 3:
          return {
            id: phaseStates.INPROCESS,
            value: "InProcess",
            title: "В процессе",
          };
        case 4:
          return {
            id: phaseStates.DONE,
            value: "Done",
            title: "Выполнено",
          };
        default:
          return null;
      }
    },
    async addComment(value) {
      this.phaseLoading = true;
      await phasesApi.addComment(this.value.id, value, this.fromRoute);
      const updateComments = await phasesApi.getPhasesComments(
        this.shippingId,
        this.value.id,
      );
      updateComments.forEach(c => {
        if (c.author.id === this.user.id || this.isAdmin) {
          c.disabled = false;
        } else {
          c.disabled = true;
        }
        c.isReaded = true;
      });
      this.currentComments = updateComments;
      this.$emit("add-comment", this.currentComments);
      this.showInfo("Комментарий добавлен");
      this.phaseLoading = false;
    },
    async markAsReadComments() {
      const unreadComments = this.currentComments
        .filter(c => !c.isReaded)
        .map(c => {
          return c.id;
        });
      if (!unreadComments.length) {
        return;
      }
      await phasesApi.markAsReadComments(
        this.shippingId,
        this.value.id,
        unreadComments,
      );
      setTimeout(
        () =>
          this.currentComments.forEach(c => {
            if (!c.isReaded) {
              c.isReaded = true;
            }
          }),
        10000,
      );
      this.$emit("readComments", true);
    },
    async deleteComment(commentId) {
      await phasesApi.deletePhasesComment(this.value.id, commentId);
      const index = this.currentComments.findIndex(c => c.id === commentId);
      this.currentComments.splice(index, 1);
    },
  },
};
</script>
